export default "__VITE_ASSET__gtVtUjcY__"